import dayjs from "dayjs";

export function cancellationPolicy(grace = 0, startDate) {
  if (!grace) return "غير مسترد";
  const diff = dayjs(startDate).diff(dayjs(), "day");

  if (diff < grace) return "غير مسترد";
  return (
    "لغاية " + dayjs(startDate).subtract(grace, "day").format("DD/MM/YYYY")
  );
}
